<div class="category-selector">
  <label class="spen-mod-select">
    <select class="select" data-cy="categories" (change)="onChangeCategory($event)" [style.min-width]="selectOptionWidth">
      <option class="is-all-point select-option" [value]="null" [selected]="isSelectedCategory(null)">すべて</option>
      @for (category of categories; track category.id) {
        <option class="is-part-point select-option" [value]="category.id" [selected]="isSelectedCategory(category)">
          {{ category.name }}
        </option>
      }
    </select>
    <i class="fa fa-caret-down"></i>
  </label>
  <label class="spen-mod-select">
    <select
      class="select"
      data-cy="sub-categories"
      [disabled]="isNoSubCategories()"
      (change)="onChangeSubCategory($event)"
      [style.min-width]="selectOptionWidth"
    >
      <option class="is-all-point select-option" [value]="null" [selected]="isSelectedSubCategory(null)">すべて</option>
      @for (subCategory of subCategories; track subCategory) {
        <option class="is-part-point select-option" [value]="subCategory.id" [selected]="isSelectedSubCategory(subCategory)">
          {{ subCategory.name }}
        </option>
      }</select
    ><i class="fa fa-caret-down"></i>
  </label>
</div>
